import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
  Outlet,
} from "react-router-dom";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import Login from "./components/Login";
import Dashboard from "./components/Dashboard";
import UserManagement from "./components/UserManagement";
import Header from "./components/Header";
import Sidebar from "./components/Sidebar";
// import Products from "./components/Products";
import { lazy, Suspense } from "react";
import OrderManagement from "./components/OrderManagement";
const Products = lazy(() => import("./components/Products"));

// Private route wrapper
const PrivateRoute = ({ children }) => {
  const { user } = useAuth();
  return user ? children : <Navigate to="/login" />;
};

const AdminRoute = ({ children }) => {
  const { user } = useAuth();

  if (!user) {
    // Not logged in
    return <Navigate to="/login" />;
  }

  if (user.role !== "admin") {
    // Logged in but not admin: redirect or show "not authorized"
    return <Navigate to="/dashboard" />; // or custom "Unauthorized" page
  }

  return children;
};

// Layout with sidebar + header
const MainLayout = () => (
  <div className="flex">
    <Sidebar />
    <div className="flex-1">
      <Header />
      <main className="p-6">
        <Outlet />
      </main>
    </div>
  </div>
);

const App = () => (
  <AuthProvider>
    <Router>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/" element={<Navigate to="/dashboard" />} />

        {/* All protected routes wrapped with layout and PrivateRoute */}
        <Route
          element={
            <PrivateRoute>
              <MainLayout />
            </PrivateRoute>
          }
        >
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/products" element={<Suspense fallback={<div>Loading...</div>}>
            <Products />
          </Suspense>} />
          <Route path="/orders-management" element={<OrderManagement />} />
          <Route
            path="/user-management"
            element={
              <AdminRoute>
                <UserManagement />
              </AdminRoute>
            }
          />
        </Route>
      </Routes>

      <ToastContainer position="top-right" autoClose={3000} />
    </Router>
  </AuthProvider>
);

export default App;
